module.exports = __webpack_public_path__ + "3ba10c54812d768dc48e6dff41e04b93.svg";